module.exports = __webpack_public_path__ + "static/media/person4.bd6f22b9.png";